import * as React from "react";
import { UserID } from "src/api/APIClient";

import "./UserIDInput.css";

interface IProps {
  initialUsers?: UserID[];
  onChange: (value: UserID[]) => any;
}

interface IState {
  value: string;
}

export class UserIDInput extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    const value = (props.initialUsers || []).join(",");

    this.state = {
      value,
    } as IState;
  }

  public render() {
    const { value } = this.state;
    return (
      <div className="user-id-input">
        <input
          className="form-control"
          value={value}
          placeholder="User IDs"
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
      </div>
    );
  }

  private onBlur = () => {
    const { value } = this.state;
    const userIDs = value
      .split(",")
      // trim space from beginning and end of line
      .map(part => {
        return part.replace(/^\W*/, "").replace(/\W*$/, "") as UserID;
      })
      // filter empty lines
      .filter(id => id !== "");

    this.props.onChange(userIDs);
  };

  private onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({ value });
  };
}



// WEBPACK FOOTER //
// ./src/components/UserIDInput.tsx